import { STEP_UP_REQUIRED_ERROR_CODE } from '~/repositories/client/Client';
import { useStepUpStore } from '~/stores/StepUp';

/**
 * fetch wrapper for the generated @column/api client: when a request is rejected with
 * step_up_auth_required, run the step-up challenge (dialog via the StepUp store) and retry the request
 * once. On a cancelled or failed challenge the original 403 response flows to the caller unchanged.
 */
export const stepUpAwareFetch: typeof globalThis.fetch = async (input, init) => {
  const request = input instanceof Request && !init ? input : new Request(input, init);
  // fetch only disturbs requests that carry a body, so bodyless requests (all GETs) are re-fetchable
  // as-is; only requests with a body need the upfront clone (it must happen before fetch consumes it).
  const retryRequest = request.body ? request.clone() : request;

  const response = await fetch(request);
  if (response.status !== 403) {
    return response;
  }

  let code: unknown;
  try {
    code = ((await response.clone().json()) as { code?: unknown })?.code;
  } catch {
    return response;
  }
  if (code !== STEP_UP_REQUIRED_ERROR_CODE) {
    return response;
  }

  try {
    await useStepUpStore.getState().requireStepUp();
  } catch {
    return response;
  }

  return fetch(retryRequest);
};
